import React from 'react';
import qrCodeImage from '../assets/QRCode.jpg';
import { getWhatsAppLink, PHONE_NUMBER } from '../utils/constants';

const OrderQRCode = ({ redirectCountdown, handleStartNewOrder, context }) => (
  <div className={`order-status-screen ${context ? ` order-status-screen-for-choose-menu` : ''}`}> 
    <div className='status-header'>
      <h2 className='section-title'>Thank you For your order!</h2>
    </div>
    <div className='order-redirect-info'>
      <strong>ℹ️ Redirecting to Home Page</strong>
      <div className='order-redirect-countdown'>
        {typeof redirectCountdown === 'number' && !isNaN(redirectCountdown) ? (
          <>in {Math.floor(redirectCountdown / 60)}:{String(redirectCountdown % 60).padStart(2, '0')}</>
        ) : (
          <>in 1:00</>
        )}
      </div>
      <div className='order-redirect-message'>You will be redirected shortly...</div>
    </div>
    <div className='qr-text'>
      <strong>Scan this QR code</strong>
      <p>For Payment details please contact <a href={getWhatsAppLink()} target='_blank' rel="noreferrer" className='whatsApp-inline'>{PHONE_NUMBER}</a></p>
    </div>
    <div className='qr-block'>
      <img src={qrCodeImage} alt='Scan QR for order' className='qr-image' />
    </div>
    <div className='status-actions'>
      <button className='nav-button next-button' onClick={handleStartNewOrder}>
        Place Another Order
      </button>
    </div>
  </div>
);

export default OrderQRCode;
